function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke-linecap:round;}.b,.c{stroke:#000;stroke-linejoin:round;}.c{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m18,1v17H1V1h17m1-1H0v19h19V0h0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m15.7,3.1v12.6H3.1V3.1h12.6m1-1H2.1v14.6h14.6V2.1h0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "m18.5,15.7c0-.8-.6-1.4-1.4-1.4-.5,0-.9.2-1.2.6v-.9c0-.8-.6-1.4-1.4-1.4-.6,0-1,.3-1.3.8,0-1-.8-1.7-1.8-1.7h0c-1,0-1.8.8-1.8,1.8v-7.4c0-.6-.5-1.2-1.2-1.2s-1,.5-1,1.2v6.1c-.2-.2-.5-.4-.9-.4-.6,0-1.2.5-1.2,1.2v4.8c0,3.6,4.1,6.7,4.9,6.7h5.4c.9,0,2.9-3,2.9-4.4.1-1.9,0-4.4,0-4.4Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "b",
  x1: 7.4,
  y1: 7.9,
  x2: 7.4,
  y2: 17
}));

function SvgSchalterhand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchalterhand);
export default __webpack_public_path__ + "static/media/schalterhand.1e3b17528471b0fa54243d02a736d4d6.svg";
export { ForwardRef as ReactComponent };